// extracted by mini-css-extract-plugin
export default {"align-menu-left":"src-assets-style-scss-___select-school-menu__align-menu-left___kLC+a","align-menu-right":"src-assets-style-scss-___select-school-menu__align-menu-right___6ng5q"};